<template>
  <div>
    <b-container class="text-left mb-5 pb-5">
      <h1>{{ title }}</h1>
      <div v-if="selectedCredits.length > 0">
        <h2 class="mt-5 mb-3">Támogatott hitelek</h2>
        <b-row class="mt-4">
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedCredits, true)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedCredits, false)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
      <div v-if="selectedCapitalProducts.length > 0">
        <h2 class="mt-5 mb-3">Tőkeprogramok</h2>
        <b-row class="mt-4">
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedCapitalProducts, true)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedCapitalProducts, false)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
      <div v-if="selectedGuarantees.length > 0">
        <h2 class="mt-5 mb-3">Garanciatermék</h2>
        <b-row class="mt-4">
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedGuarantees, true)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
          <b-col cols="12" lg="6" class="p-0">
            <ul>
              <li
                v-for="(competition, index) in getSeparatedCompetitions(selectedGuarantees, false)"
                :key="`${competition.name}-${index}`"
              >
                <a :href="competition.link" target="_blank">{{ competition.name }}</a>
              </li>
            </ul>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <SmeClassificationInformation />
  </div>
</template>

<script>
import SmeClassificationInformation from '@/components/SmeClassificationInformation.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'PartnerOpportunity',
  components: {
    SmeClassificationInformation
  },
  data: function() {
    return {
      firstColumn: [],
      secondColumn: []
    }
  },
  async created() {
    await this.$store.dispatch('getSelectedCompetitions', { subType: this.subType })
    const separationSize = Math.ceil(this.selectedCompetitions.length / 2)

    this.firstColumn = this.selectedCompetitions.slice(0, separationSize)
    this.secondColumn = this.selectedCompetitions.slice(separationSize)
  },
  computed: {
    ...mapGetters(['selectedCompetitions', 'selectedCredits', 'selectedCapitalProducts', 'selectedGuarantees'])
  },
  methods: {
    getSeparatedCompetitions(competitions, isFirstColumn) {
      const separationSize = Math.ceil(competitions.length / 2)
      if (isFirstColumn) {
        return competitions.slice(0, separationSize)
      }
      return competitions.slice(separationSize)
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subType: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
ul {
  list-style: none;
  padding-left: 1rem;
  /* list-style-image: url('../../assets/img/list-bullet.svg'); */
}

li {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

li:before {
  content: '';
  display: inline-block;
  height: 2rem;
  width: 1rem;
  background-image: url('../../assets/img/list-bullet.svg');
  background-repeat: no-repeat;
  margin-right: 0.5em;
}

a:hover {
  text-decoration: none;
  color: var(--color-green);
  font-weight: bold;
}
</style>
